import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-treaty-country-pair-selector',
  templateUrl: './treaty-country-pair-selector.component.html',
  styleUrls: ['./treaty-country-pair-selector.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TreatyCountryPairSelectorComponent implements OnInit, OnDestroy {
  isHideCountryTwoSelector = true;
  countries: any[];
  countryTwoList: any[];
  ngUnsubscribe = new Subject<void>();
  @Input() selectedCountry;
  @Input() selectedCountryTwo;
  @Output() countryChange: EventEmitter<any> = new EventEmitter();
  @Output() countryTwoChange: EventEmitter<any> = new EventEmitter();
  constructor(
    private commandService: CommandService,
    private fuseSplashScreenService: FuseSplashScreenService
  ) { }

  ngOnInit(): void {
    if (!this.countries) {
      this.fuseSplashScreenService.show();
      const command = new PlatformCommand('GetTreatyCountriesPlatformCommand', Api.Treaty);
      command.fieldValues['ParentId'] = 'treaties';
      this.commandService.executePlatformCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => {
        this.fuseSplashScreenService.hide();
        this.countries = response.fieldValues['Countries'];
        this.countries = this.countries.map((country) => {
          const synonyms = country.synonyms.join('|');
          return {...country, searchValue: `${country.displayName}|${synonyms}`};
        });
      });
    }
    if (this.selectedCountry) {
      this.onCountryChangeCustom(this.selectedCountry, this.selectedCountryTwo);
    }
  }
  onCountryChange(country) {
    this.onCountryChangeCustom(country);
  }
  onCountryChangeCustom(countryOne, countryTwo = null) {
    this.selectedCountry = countryOne;
    this.updateCountryTwoList(countryOne, countryTwo);
  }

  onCountryTwoChange(country) {
    this.selectedCountryTwo = country;
    this.countryTwoChange.emit({
      countryOne: this.selectedCountry,
      countryTwo: this.selectedCountryTwo
    });
  }

  updateCountryTwoList(country: any, countryTwo = null) {
    this.fuseSplashScreenService.show();
    const command = new PlatformCommand('GetTreatyCountriesPlatformCommand', Api.Treaty);
    command.fieldValues['ParentId'] = `treaties-${country.id}`;
    this.countryTwoList = null;
    this.isHideCountryTwoSelector = false;
    this.selectedCountryTwo = countryTwo;
    this.commandService.executePlatformCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => {
      this.countryTwoList = response.fieldValues['Countries'];
      this.countryTwoList = this.countryTwoList.map((country) => {
        const synonyms = country.synonyms.join('|');
        return {...country, searchValue: `${country.displayName}|${synonyms}`};
      });
      if (this.selectedCountryTwo) {
        this.selectedCountryTwo = this.countryTwoList.find(x => x.id === this.selectedCountryTwo.id);
      }
      this.countryChange.emit({
        countryOne: this.selectedCountry,
        countryTwo: this.selectedCountryTwo
      });
      this.fuseSplashScreenService.hide();
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


}
